var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-donation"},[_c('PageContainer',{attrs:{"banner":false}},[_c('ClientOnly',[_c('DonationsShow',{attrs:{"id":_vm.id}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }